//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { listCategories } from '@/api/category.js';
import { listChannelCategoryTree } from '@motionelements/core/src/api/channel.js';
import { convertRouteToMediaTypeCode } from '@/helpers/mediaType.js';
import PageLoader from '@motionelements/core/src/components/ui/PageLoader.vue';
import CategoryTreeCard from '@/components/landing/category/CategoryTreeCard.vue';

// channel routes
const ROUTE_MEDIA_TYPES = [
  'video',
  'music',
  'sound-effects',
  'stock-image',
  'gif',
  '3d',
  'lottie',
  'graphic',
  'after-effects-templates',
  'premiere-pro-templates',
  'apple-motion-templates',
  'davinci-resolve-templates',
  'ui',
  'notion',
  'presentation',
  'image-prompts',
];

const CATEGORY_TYPE_ORDER = ['category', 'style', 'type'];

const CATEGORY_TYPE_LABELS = {
  category: 'Categories',
  style: 'Styles',
  type: 'By type',
};

export default {
  name: 'media-type-categories',
  components: {
    CategoryTreeCard,
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    Breadcrumbs: () => import('@motionelements/core/src/components/ui/BaseBreadcrumbs.vue'),
    PageLoader,
  },
  data() {
    return {
      categories: [],
      videoCategoryTree: [],
      loading: true,
    };
  },
  computed: {
    mediaTypeCode() {
      return convertRouteToMediaTypeCode(this.$route.params.mediaType);
    },
    isVideo() {
      return this.mediaTypeCode === 'video';
    },
    hasContent() {
      if (this.isVideo) {
        return this.videoCategoryTree.length > 0;
      }
      return this.categories.length > 0;
    },
    mediaTypeLabel() {
      return this.$term('mediaType', this.mediaTypeCode).text();
    },
    pageTitle() {
      return `${this.mediaTypeLabel} Categories`;
    },
    pageDescription() {
      return `Browse all ${this.mediaTypeLabel.toLowerCase()} categories. Find royalty-free assets by category.`;
    },
    breadcrumbList() {
      return [
        { name: this.mediaTypeLabel, link: this.$link(this.$tools.getChannelUrl(this.mediaTypeCode)).url() },
        { name: this.pageTitle, link: this.$link(this.$route.path).url(), active: true },
      ];
    },
    categoriesByType() {
      const byType = _.groupBy(this.categories, (cat) => _.get(cat, 'type', 'other'));
      const order = [...CATEGORY_TYPE_ORDER];
      Object.keys(byType).forEach((t) => {
        if (!order.includes(t)) order.push(t);
      });
      return order.filter((t) => byType[t] && byType[t].length).map((type) => ({
        type,
        label: CATEGORY_TYPE_LABELS[type] || _.capitalize(type),
        categories: byType[type],
      }));
    },
  },
  async fetch() {
    const routeMediaType = this.$route.params.mediaType;
    if (!ROUTE_MEDIA_TYPES.includes(routeMediaType)) {
      this.$nuxt.context.error({ statusCode: 404, message: 'Not found' });
      return;
    }

    const mediaType = convertRouteToMediaTypeCode(routeMediaType);
    try {
      if (mediaType === 'video') {
        const response = await listChannelCategoryTree('video', {
          'fields[category]': 'id,name,url,image,items',
        });
        this.videoCategoryTree = _.get(response, 'data.data', []);
      } else {
        const response = await listCategories(mediaType);
        this.categories = _.get(response, 'data.data', []);
      }
    } catch (err) {
      const statusCode = _.get(err, 'response.status', 500);
      const message = _.get(err, 'response.data.message', err.message) || 'Failed to load categories';
      this.$nuxt.context.error({ statusCode, message });
    } finally {
      this.loading = false;
    }
  },
  fetchOnServer: true,
  methods: {
    categoryUrl(cat) {
      const url = _.get(cat, 'html.url', '');
      if (!url) return '';
      try {
        return url.startsWith('/') ? this.$link(url).fullPath() : this.$link(new URL(url).pathname).fullPath();
      } catch {
        return url;
      }
    },
    categoryName(cat) {
      return _.get(cat, 'html.title', '') || _.get(cat, 'name', '') || `Category ${_.get(cat, 'id', '')}`;
    },
    catHtmlDescription(cat) {
      const desc = _.get(cat, 'html.description', '');
      if (typeof desc !== 'string') return '';
      return desc.replace(/<[^>]+>/g, '').trim();
    },
    categoryThumbUrl(cat) {
      const thumbs = _.get(cat, 'thumbnails', []);
      const first = Array.isArray(thumbs) && thumbs.length ? thumbs[0] : null;
      return (first && first.url) ? first.url : '';
    },
  },
};
